import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Layout, Menu } from 'antd'; // Using Ant Design layout if available, or just simple divs
import { SearchOutlined, FileTextOutlined } from '@ant-design/icons';
import SearchPage from './Components/SearchPage';
import LogViewer from './Components/LogViewer';
import './App.css'; // Access global styles if needed

const { Header, Content } = Layout;

const App: React.FC = () => {
  return (
    <Router>
      <Layout className="layout">
        <Header>
          <div className="logo" />
          <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['1']}>
            <Menu.Item key="1" icon={<SearchOutlined />}>
              <Link to="/">Search</Link>
            </Menu.Item>
            <Menu.Item key="2" icon={<FileTextOutlined />}>
              <Link to="/logs">Logs</Link>
            </Menu.Item>
          </Menu>
        </Header>
        <Content style={{ padding: '0 50px' }}>
          <div className="site-layout-content" style={{ marginTop: '20px' }}>
            <Routes>
              <Route path="/" element={<SearchPage />} />
              <Route path="/logs" element={<LogViewer />} />
            </Routes>
          </div>
        </Content>
      </Layout>
    </Router>
  );
};

export default App;
